var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35269 12.9424L5.19313 12.689C5.11393 12.1119 5.08714 11.5288 5.11311 10.9469L3.25714 10.8644C3.22623 11.5586 3.25821 12.254 3.35269 12.9424V12.9424Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6229 22.7543C16.1584 22.7543 17.6484 22.4533 19.0517 21.8598C20.4065 21.2867 21.6231 20.4665 22.6677 19.422C23.7122 18.3774 24.5325 17.1608 25.1055 15.8059C25.699 14.4026 26 12.9126 26 11.3771C26 9.84162 25.6991 8.35159 25.1055 6.94834C24.5325 5.59347 23.7122 4.37685 22.6677 3.3323C21.6231 2.28776 20.4065 1.46755 19.0517 0.894463C17.6484 0.300956 16.1584 0 14.6229 0C11.6734 0 8.87697 1.12401 6.74887 3.16497C4.62737 5.19962 3.3873 7.93396 3.25714 10.8643L5.11311 10.9468C5.33949 5.85019 9.51669 1.85783 14.6229 1.85783C19.8719 1.85783 24.1422 6.1282 24.1422 11.3771C24.1422 16.6261 19.8719 20.8965 14.6229 20.8965C12.5978 20.8965 10.6645 20.2693 9.0322 19.0828L7.93987 20.5854C9.89173 22.0043 12.2027 22.7543 14.6229 22.7543V22.7543Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53463 14.6794C4.77235 14.6794 5.01008 14.5887 5.19143 14.4073L8.60131 10.9975C8.96407 10.6347 8.96407 10.0466 8.60131 9.68382C8.23857 9.32105 7.65042 9.32105 7.28768 9.68382L3.87783 13.0937C3.51507 13.4564 3.51507 14.0446 3.87783 14.4073C4.05921 14.5887 4.29694 14.6794 4.53463 14.6794V14.6794Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33875 14.7396C4.5765 14.7396 4.81416 14.649 4.99555 14.4675C5.35831 14.1048 5.35831 13.5167 4.99555 13.1539L1.5857 9.74404C1.22299 9.3813 0.634838 9.3813 0.272073 9.74404C-0.0906911 10.1068 -0.0906911 10.6949 0.272073 11.0577L3.68195 14.4675C3.86327 14.6489 4.10105 14.7396 4.33875 14.7396V14.7396Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon_reset.03c0324831a47dcd4ff8369904896ec3.svg";
export { ForwardRef as ReactComponent };